/**
 * Cooling system create/update payload helpers (#996 Phase 2).
 */

import type { CoolingSystemConfiguration } from '../types/coolingSystem';

/** Strip server metadata before POST /requests/:id/cooling-systems */
export function toCreateCoolingSystemPayload(
  unit: CoolingSystemConfiguration,
): Omit<CoolingSystemConfiguration, 'id' | 'createdAt' | 'updatedAt'> {
  const {
    id: _id,
    createdAt: _createdAt,
    updatedAt: _updatedAt,
    ...payload
  } = unit;
  return payload;
}
